// extracted by mini-css-extract-plugin
export default {"header":"page-analyzer-drawer_header__8eo0R","content-container":"page-analyzer-drawer_content-container__OTkxa"};